<template>
    <div>
        <vue-headful :title="'Employee Settings :: MeritEHS'"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees`">
                        <i class="fa fa-group"></i> Employees
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Settings</li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
            <b-nav-item :active="curTab === 'general'" @click="curTab = 'general'">
                Employee Data Settings
            </b-nav-item>
            <b-nav-item :active="curTab === 'custom_fields'" @click="curTab = 'custom_fields'">
                Custom Fields
            </b-nav-item>
        </ul>

        <div class="row">
            <div class="col-12">
                <div v-show="curTab === 'general'">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div class="row mb-2">
                                        <div class="col-md-3 text-md-right text-muted">Employee# Value Type:</div>
                                        <div class="col-md-6">
                                            <b-form-select v-model="settings.emp_nbr_value_type" size="sm" :options="[{value: 'Alphanumeric', text: 'Alphanumeric'}, {value: 'Numeric', text: 'Numeric'}]" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card mb-4">
                                <div class="card-header">
                                    Employee Profile - Additional Required Fields<br/>
                                    <small class="text-muted">These settings allow you to specify which optional fields you want to require on profile creation.</small>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-2" v-for="(field, i) in settings.required_fields">
                                        <div class="col-md-3 text-md-right text-muted">Field to Require:</div>
                                        <div class="col-md-6">
                                            <b-form-select v-model="settings.required_fields[i]" :options="requiredFieldOptions" size="sm" />
                                        </div>
                                        <div class="col-md-3">
                                            <button type="button" class="btn btn-sm btn-default" v-on:click="settings.required_fields.splice(i, 1)">
                                                <i class="fa fa-trash text-danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <hr/>

                                    <a href="javascript:void(0)" v-on:click="settings.required_fields.push(null)" style="display: block; text-align: center; padding: 6px 8px; border: 1px dashed rgb(204, 204, 204);">
                                        -- <i class="fa fa-plus-circle text-success"></i> Add a Field --
                                    </a>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header">
                                    Enable Fields on Public QR Code Profile View<br/>
                                    <small class="text-muted">These settings allow you to show specific fields on the Employees' public profile QR code page.</small>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-2" v-for="(field, i) in settings.public_fields">
                                        <div class="col-md-3 text-md-right text-muted">Field to Show:</div>
                                        <div class="col-md-6">
                                            <b-form-select v-model="settings.public_fields[i].attribute_name" :options="publicFieldOptions" size="sm" />
                                        </div>
                                        <div class="col-md-3">
                                            <button type="button" class="btn btn-sm btn-default" v-on:click="settings.public_fields.splice(i, 1)">
                                                <i class="fa fa-trash text-danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <hr/>

                                    <a href="javascript:void(0)" v-on:click="settings.public_fields.push({attribute_name: null})" style="display: block; text-align: center; padding: 6px 8px; border: 1px dashed rgb(204, 204, 204);">
                                        -- <i class="fa fa-plus-circle text-success"></i> Add a Field --
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <button class="btn btn-sm btn-success" type="button" @click="saveSettings('settings')">Save Settings</button>
                    </div>
                </div>

                <div v-show="curTab === 'custom_fields'">
                    <div v-if="loading" class="text-center">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                    </div>
                    <div v-else>
                        <custom-field-builder ref="empCustomFieldBuilder" :starting_sections="sections" @customFieldsSaved="saveSettingsCustomFields" asset_type="Employee"></custom-field-builder>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                saving: false,
                loading: true,
                curTab: 'general',
                sections: [],
                settings: {},
                public_fields: [],
                required_fields: [],
                errors: [],
            }
        },

        watch: {
            curTab(newValue, oldValue) {
                if (newValue)
                {
                    if (newValue === 'general')
                    {
                        window.history.replaceState(null,null,`${this.$route.path}`)
                    }
                    else
                    {
                        window.history.replaceState(null,null,`${this.$route.path}#${this.curTab}`)
                    }
                }
            },
        },

        computed: {
            publicFieldOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Field --'}];

                //Setup Keys
                var keys = Object.keys(this.public_fields);

                //Loop and Build
                for (var i = 0; i < keys.length; i++)
                {
                    //Push
                    options.push({value: keys[i], text: this.public_fields[keys[i]]});
                }

                //Send it
                return options;
            },

            requiredFieldOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Field --'}];

                //Setup Keys
                var keys = Object.keys(this.required_fields);

                //Loop and Build
                for (var i = 0; i < keys.length; i++)
                {
                    //Push
                    options.push({value: keys[i], text: this.required_fields[keys[i]]});
                }

                //Send it
                return options;
            },
        },

        methods: {
            getSettings() {
                //Get the data
                this.loading = true;
                this.$http
                    .get('employees/settings')
                    .then(response => {
                        //Set all the data
                        this.sections = response.data.sections;
                        this.settings = response.data.settings;
                        this.public_fields = response.data.public_fields;
                        this.required_fields = response.data.required_fields;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSettingsCustomFields(sections){
                //Send it
                this.sections = sections;

                //Save it
                this.saveSettings('custom_fields');
            },

            saveSettings(type) {
                //SHow loading
                this.saving = true;

                //Reset Errors
                this.errors = [];

                //Update the errors for the Custom Field Builder
                this.$refs.empCustomFieldBuilder.setErrors([]);

                //Send it
                this.$http.post('employees/settings', {save_type: type, sections: this.sections, settings: this.settings})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Settings Saved');
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;

                        //Update the errors for the Custom Field Builder
                        this.$refs.empCustomFieldBuilder.setErrors(this.errors);
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //Get the Settings
            this.getSettings();

            //Check for Hash
            if (this.$route.hash !== '' && this.$route.hash !== '#')
            {
                this.curTab = this.$route.hash.replace('#','')
            }
        },
    }
</script>